import { useTranslation } from "react-i18next";
import { LanguageSelector } from "./LanguageSelector";

export function Footer() {
  const { t } = useTranslation();

  return (
    <div className="footer-container">
      <LanguageSelector />
      <div className="legal-links">
        <a href="https://www.id.me/about" target="_blank" rel="noopener noreferrer" className="legal-link">{t('face.footer.links.whatIsIdme')}</a>
        <span className="link-separator">|</span>
        <a href="https://www.id.me/terms" target="_blank" rel="noopener noreferrer" className="legal-link">{t('face.footer.links.termsOfService')}</a>
        <span className="link-separator">|</span>
        <a href="https://www.id.me/privacy" target="_blank" rel="noopener noreferrer" className="legal-link">{t('face.footer.links.privacyPolicy')}</a>
      </div>
    </div>
  );
}